import JSZip from 'jszip'
import { v1 as Uuid } from 'uuid'
import {closest} from '@/components/js/Utils.js'
import ES from '@/components/js/EditorSetting.js'

export default class Epub {
  static INDEX = 'uil'
  static FOOTNOTE_HREF = '#ufn'
  static FOOTNOTE_ID = 'ufnv'

  title // 제목설정
  creator // 저자
  illustrator // 일러스트
  dsr // 타이포
  publisher // 발행
  addr // 주소?
  email // 이메일
  date // 발행일
  isbn // isbn
  setIsbn // 세트 isbn
  isEpubInfo // 판권지 여부

  cover // cover 이미지
  coverName // cover 목차 이름

  sectionList // section 리스트
  footnotelist // 주석 리스트
  indexList // 목차 리스트

  create (cb) {
    console.log(this.title)
    var xm = '<?xml version="1.0" encoding="utf-8"?>\n'
    var con = this.createContainer()
    var uuid = Uuid()
    var footl = this.createFootnote()
    var foot = this.createPage(this.createElement('title', '주석'), [
      this.createElement('h2', '주석'),
      this.createElement('p', '<br/>', true),
      this.createElement('p', '<br/>', true)
    ].concat(footl))
    var pack = this.createPackage(uuid, footl.length)
    var tocs = '<!DOCTYPE ncx PUBLIC "-//NISO//DTD ncx 2005-1//EN" "http://www.daisy.org/z3986/2005/ncx-2005-1.dtd">\n'
    var page = '<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.1//EN" "http://www.w3.org/TR/xhtml11/DTD/xhtml11.dtd">\n'
    var cover = this.createCover()
    var epub = this.createEpubInfoPage()
    var secList = this.createSection()
    var imgFile = secList.img
    secList = secList.section
    var t = this.createIndex(uuid, secList, footl.length)
    var sty = this.createCss()

    var zip = new JSZip()
    zip.file('mimetype', 'application/epub+zip', {compression: 'STORE'})
    zip.folder('META-INF').file('container.xml', xm + this.replaceTag(con.outerHTML))
    console.log('create', this.cover)
    if (this.cover) {
      console.log(this.cover.split(',')[1])
      zip.folder('OEBPS').folder('Images').file('cover-1.jpg', this.cover.split(',')[1], {base64: true})
    }
    imgFile.forEach((n, idx) => {
      pack.querySelector('manifest').appendChild(this.createElement('item', {
        'id': n.name,
        'href': 'Images/' + n.name,
        'media-type': 'image/jpeg'
      }))
      zip.folder('OEBPS').folder('Images').file(n.name, n.file, {base64: true})
    })
    zip.folder('OEBPS').file('content.opf', xm + this.replaceTag(pack.outerHTML))
    console.log(xm + this.replaceTag(pack.outerHTML))
    zip.folder('OEBPS').file('toc.ncx', xm + tocs + this.replaceTag(t.outerHTML.replace(/<br>/gim, '')))
    console.log(xm + tocs + this.replaceTag(t.outerHTML.replace(/<br>/gim, '')))
    zip.folder('OEBPS').folder('Styles').file('Style.css', sty)
    if (this.cover) {
      zip.folder('OEBPS').folder('Text').file('cover.xhtml', xm + page + this.replaceTag(cover.outerHTML))
    }
    var idxcount = 1
    if (this.isEpubInfo) {
      zip.folder('OEBPS').folder('Text').file('U0001.xhtml', xm + page + this.replaceTag(epub.outerHTML))
      idxcount++
    }
    secList.forEach((n, i) => {
      zip.folder('OEBPS').folder('Text').file(this.getPageNumber(idxcount), xm + page + this.replaceTag(n.outerHTML))
      idxcount++
    })
    if (footl.length > 0) {
      zip.folder('OEBPS').folder('Text').file('footnote.xhtml', xm + page + this.replaceTag(foot.outerHTML))
    }
    // 압축하는 부분 어떻게 처리할지는 봐야함
    zip.generateAsync({
      type: 'blob',
      mimeType: 'application/epub+zip',
      compression: 'DEFLATE'
    }).then((f) => {
      console.log(f)
      if (cb) {
        cb(f)
      }
    })
  }

  createFootnote () {
    var footl = []
    this.footnotelist.forEach((n, idx) => {
      console.log('footnote', n, idx)
      n.forEach((ni, nidx) => {
        console.log('footnote item', ni, nidx)
        if (ni) {
          var si = this.sectionList[idx]
          var tk = si.querySelector('#' + ni.id)
          tk.href = '../Text/footnote.xhtml' + ni.href
          tk = closest(si.querySelector('#' + n.id), [ES.SECTION, ES.LINE, ES.IMG, ES.INDEX, ES.BLOCK, ES.ENTER])
          var step = (this.isEpubInfo) ? 2 : 1
          var itemp = this.getPageNumber(idx + step)
          var footText = (ni.title === '') ? ni.message : ni.title + ' : ' + ni.message
          tk = this.createElement('p', this.createElement('a', {
            'id': ni.href.split('#')[1],
            'href': '../Text/' + itemp + '#' + ni.id
          }, (footl.length + 1) + ')').outerHTML + '&#160;' + footText, true)
          footl.push(tk)
        }
      })
    })
    return footl
  }

  createContainer () {
    var con = this.createElement('container', {
      'xmlns': 'urn:oasis:names:tc:opendocument:xmlns:container',
      'version': '1.0'
    })
    var rs = this.createElement('rootfiles')
    rs.appendChild(this.createElement('rootfile', {
      'full-path': 'OEBPS/content.opf',
      'media-type': 'application/oebps-package+xml'
    }))
    con.appendChild(rs)
    return con
  }

  createElement (t, a, v, h) {
    var tag = document.createElement(t)
    if (a instanceof Object) {
      for (var k in a) {
        tag.setAttribute(k, a[k])
      }
    } else {
      if (a) {
        h = v
        v = a
      }
    }
    if (v) {
      if (h) {
        tag.innerHTML = v
      } else {
        tag.innerText = v
      }
    }
    return tag
  }

  createPackage (uuid, footlength) {
    var p = this.createElement('package', {
      'version': '2.0',
      'unique-identifier': 'BookId',
      'xmlns': 'http://www.idpf.org/2007/opf'
    })
    var m = this.createElement('metadata', {
      'xmlns:opf': 'http://www.idpf.org/2007/opf',
      'xmlns:dc': 'http://purl.org/dc/elements/1.1/'
    })
    m.appendChild(this.createElement('dc:title', this.title))
    m.appendChild(this.createElement('dc:creator', {'opf:role': 'aut'}, this.creator))
    if (this.illustrator && this.illustrator !== '') {
      m.appendChild(this.createElement('dc:contributor', {'opf:role': 'ill'}, this.illustrator))
    }
    if (this.dsr && this.dsr !== '') {
      m.appendChild(this.createElement('dc:contributor', {'opf:role': 'dsr'}, this.dsr))
    }
    console.log(this.date)
    m.appendChild(this.createElement('dc:date', {'opf:event': 'modification'}, this.date.toString().replace(/[^0-9]/g, '').replace(/^(\d{4})(\d{2})(\d{2})/, '$1-$2-$3')))
    m.appendChild(this.createElement('dc:publisher', this.publisher))
    m.appendChild(this.createElement('dc:language', 'ko'))
    if (this.cover) {
      m.appendChild(this.createElement('meta', {'name': 'cover', 'content': 'cover-1.jpg'}))
    }
    m.appendChild(this.createElement('dc:identifier', {'opf:scheme': 'ISBN'}, this.isbn))
    m.appendChild(this.createElement('dc:identifier', {'opf:scheme': 'UUID', 'id': 'BookId'}, 'urn:uuid:' + uuid))
    p.appendChild(m)
    var ms = this.createElement('manifest')
    ms.appendChild(this.createElement('item', {
      'id': 'ncx',
      'href': 'toc.ncx',
      'media-type': 'application/x-dtbncx+xml'
    }))
    ms.appendChild(this.createElement('item', {
      'id': 'Style.css',
      'href': 'Styles/Style.css',
      'media-type': 'text/css'
    }))
    var s = this.createElement('spine', {'toc': 'ncx'})
    var g
    if (this.cover) {
      g = this.createElement('guide')
      ms.appendChild(this.createElement('item', {
        'id': 'cover-1.jpg',
        'href': 'Images/cover-1.jpg',
        'media-type': 'image/jpeg'
      }))
      ms.appendChild(this.createElement('item', {
        'id': 'cover.xhtml',
        'href': 'Text/cover.xhtml',
        'media-type': 'application/xhtml+xml'
      }))
      s.appendChild(this.createElement('itemref', {'idref': 'cover.xhtml'}))
      g.appendChild(this.createElement('reference', {
        'type': 'cover',
        'title': '표지',
        'href': 'Text/cover.xhtml'
      }))
    }
    var idx = 1
    var itemp
    if (this.isEpubInfo) {
      itemp = this.getPageNumber(idx)
      ms.appendChild(this.getXmlItem(itemp))
      s.appendChild(this.createElement('itemref', {'idref': itemp}))
      idx++
    }
    this.sectionList.forEach((n, i) => {
      itemp = this.getPageNumber(idx)
      ms.appendChild(this.getXmlItem(itemp))
      s.appendChild(this.createElement('itemref', {'idref': itemp}))
      idx++
    })
    if (footlength > 0) {
      ms.appendChild(this.createElement('item', {
        'id': 'footnote.xhtml',
        'href': 'Text/footnote.xhtml',
        'media-type': 'application/xhtml+xml'
      }))
      s.appendChild(this.createElement('itemref', {'idref': 'footnote.xhtml'}))
    }
    p.appendChild(ms)
    p.appendChild(s)
    if (this.cover) {
      p.appendChild(g)
    }
    return p
  }

  getPageNumber (id) {
    switch (id.toString().length) {
      case 1 : return 'U000' + id + '.xhtml'
      case 2 : return 'U00' + id + '.xhtml'
      case 3 : return 'U0' + id + '.xhtml'
      case 4 : return 'U' + id + '.xhtml'
    }
  }

  getXmlItem (id) {
    return this.createElement('item', {
      'id': id,
      'href': 'Text/' + id,
      'media-type': 'application/xhtml+xml'
    })
  }

  createCover () {
    var h1 = this.createElement('h1', {
      'class': 'center',
      'title': '표지 &lt;' + this.title + '&gt;'
    })
    h1.appendChild(this.createElement('img', {
      'class': 'cover',
      'alt': 'cover',
      'src': '../Images/cover-1.jpg'
    }))
    return this.createPage(this.createElement('title', '표지'), [h1], true)
  }

  createPage (h, b, img) {
    var page
    if (img) {
      page = this.createElement('html', {
        'xmlns': 'http://www.w3.org/1999/xhtml'
      })
    } else {
      page = this.createElement('html', {
        'xmlns': 'http://www.w3.org/1999/xhtml',
        'xmlns:xml': 'http://www.w3.org/XML/1998/namespace',
        'xml:lang': 'ko'
      })
    }
    var head = this.createElement('head')
    if (h instanceof Array) {
      b = h
    } else {
      head.appendChild(h)
    }
    head.appendChild(this.createElement('link', {
      'href': '../Styles/Style.css',
      'rel': 'stylesheet',
      'type': 'text/css'
    }))
    var body = this.createElement('body')
    page.appendChild(head)
    page.appendChild(body)
    b.forEach((n) => {
      console.log('check', n.outerHTML)
      if (n.align) {
        n.classList.add(n.align)
        n.removeAttribute('align')
      }
      n.querySelectorAll('p').forEach(k => {
        if (k.align) {
          k.classList.add(k.align)
          k.removeAttribute('align')
        }
      })
      body.appendChild(n)
    })
    return page
  }

  createEpubInfoPage () {
    var st = '저자 ' + this.creator
    if (this.illustrator && this.illustrator !== '') {
      st += '<br/>일러스트 ' + this.illustrator
    }
    if (this.dsr && this.dsr !== '') {
      st += '<br/>타이포 ' + this.dsr
    }
    st += '<br/>발행처 ' + this.publisher + '<br/>제작 유펜비<br/>' + this.addr + '<br/>' + this.email
    if (this.setIsbn) {
      return this.createPage(this.createElement('title'), [
        this.createElement('p', st, true),
        this.createElement('p', this.date),
        this.createElement('p', 'ISBN&#160;' + this.isbn + '<br/>&#160; &#160; &#160; &#160; ' + this.setIsbn + '(세트)', true),
        this.createElement('h2', {'title': '판권지'}, '<br/>', true),
        this.createElement('p', '저작권자 및 출판사의 서면 동의 없이<br/>책의 내용을 무단 복사, 수정, 배포하는 것을 금합니다.', true)
      ])
    } else {
      return this.createPage(this.createElement('title'), [
        this.createElement('p', st, true),
        this.createElement('p', this.date),
        this.createElement('p', 'ISBN&#160;' + this.isbn + '<br/>', true),
        this.createElement('h2', {'title': '판권지'}, '<br/>', true),
        this.createElement('p', '저작권자 및 출판사의 서면 동의 없이<br/>책의 내용을 무단 복사, 수정, 배포하는 것을 금합니다.', true)
      ])
    }
  }

  createSection () {
    var secList = []
    var imgFile = []
    this.sectionList.forEach((n, i) => {
      n.querySelectorAll('img').forEach((im, idx) => {
        var np = this.getImgNumber(imgFile.length + 1)
        imgFile.push({file: im.src.split(',')[1], name: np})
        im.removeAttribute('id')
        im.src = '../Images/' + np
        im.alt = np
      })
      secList.push(this.createPage(this.createElement('title'), [...new Set(n.childNodes)]))
    })
    console.log(imgFile)
    return {section: secList, img: imgFile}
  }

  getImgNumber (id) {
    switch (id.toString().length) {
      case 1 : return 'U000' + id + '.jpg'
      case 2 : return 'U00' + id + '.jpg'
      case 3 : return 'U0' + id + '.jpg'
      case 4 : return 'U' + id + '.jpg'
    }
  }

  createIndex (uuid, secList, footlength) {
    var t = this.createElement('ncx', {'xmlns': 'http://www.daisy.org/z3986/2005/ncx/', 'version': '2005-1'})
    var h = this.createElement('head')
    h.appendChild(this.createElement('meta', {'content': 'urn:uuid:' + uuid, 'name': 'dtb:uid'}))
    h.appendChild(this.createElement('meta', {'content': '3', 'name': 'dtb:depth'}))
    h.appendChild(this.createElement('meta', {'content': '0', 'name': 'dtb:totalPageCount'}))
    h.appendChild(this.createElement('meta', {'content': '0', 'name': 'dtb:maxPageNumber'}))
    t.appendChild(h)
    var d = this.createElement('docTitle')
    d.appendChild(this.createElement('text', this.title))
    t.appendChild(d)
    var n = this.createElement('navMap')
    var p, itemp
    var idx = 1
    var idxcount = 1
    if (this.cover) {
      p = this.createNavPoint(idx, this.coverName, 'Text/cover.xhtml')
      idx++
      n.appendChild(p)
    }
    if (this.isEpubInfo) {
      // itemp = this.getPageNumber(idxcount)
      // p = this.createNavPoint(idx, '판권지', 'Text/' + itemp)
      // idx++
      idxcount++
      // n.appendChild(p)
    }
    this.indexList.forEach((item, i) => {
      var findidx = secList.findIndex((el) => el.querySelector('#' + item.id) !== null)
      itemp = this.getPageNumber(findidx + idxcount)
      p = this.createNavPoint(idx, item.name, 'Text/' + itemp + '#' + item.id)
      idx++
      switch (item.step) {
        case 0 :
          n.appendChild(p)
          break
        case 1 :
          n.lastChild.appendChild(p)
          break
        case 2 :
          n.lastChild.lastChild.appendChild(p)
          break
        default :
          n.appendChild(p)
          break
      }
    })
    if (footlength) {
      p = this.createNavPoint(idx, '주석', 'Text/footnote.xhtml')
      n.appendChild(p)
    }
    if (!n.childNodes.length) {
      n.appendChild(this.createNavPoint(1, '기본', 'Text/U001.xhtml'))
    }
    t.appendChild(n)
    return t
  }

  createNavPoint (i, name, src) {
    var t = this.createElement('navPoint', {
      'id': 'navPoint-' + i,
      'playOrder': i
    })
    var txt = this.createElement('navLabel')
    txt.appendChild(this.createElement('text', name))
    t.appendChild(txt)
    t.appendChild(this.createElement('content', {'src': src}))
    return t
  }

  replaceTag (st) {
    st = st.replace(/u_index |u_tag /gim, '')
    st = st.replace(/<meta (.*?)>/gim, '<meta $1 />').replace(/<img (.*?)>/gim, '<img $1 />').replace(/<link (.*?)>/gim, '<link $1 />')
    st = st.replace(/<br>/gim, '<br/>')
    // st = st.replace(/<font size="(.*?)" color="(.*?)">(.*?)<\/font>/gim, '<span class="fontReform$1" style="color: $2">$3</span>')
    // st = st.replace(/<font color="(.*?)" size="(.*?)">(.*?)<\/font>/gim, '<span class="fontReform$2" style="color: $1">$3</span>')
    st = st.replace(/<font size="(.*?)">(.*?)<\/font>/gim, '<span class="fontReform$1">$2</span>')
    st = st.replace(/<font color="(.*?)">(.*?)<\/font>/gim, '<span style="color: $1">$2</span>')
    st = st.replace(/<font face="(.*?)">(.*?)<\/font>/gim, '$2')
    st = st.replace(/ face="(.*?)"/gim, '')
    st = st.replace(/ size="(.*?)"/gim, ' class="fontReform$1"')
    st = st.replace(/ color="(.*?)"/gim, ' style="color: $1"')
    st = st.replace(/<u>(.*?)<\/u>/gim, '<span class="underline">$1</span>')
    st = st.replace(/<strike>(.*?)<\/strike>/gim, '<span class="strike">$1</span>')
    st = st.replace(/<strike (.*?)>(.*?)<\/strike>/gim, '<span class="strike" $1>$2</span>')
    st = st.replace(/<s>(.*?)<\/s>/gim, '<span class="strike">$1</span>')
    st = st.replace(/doctitle/gim, 'docTitle')
    st = st.replace(/playorder/gim, 'playOrder')
    st = st.replace(/<blockquote (.*?)>(.*?)<\/blockquote>/gim, '<div $1>$2</div>')
    st = st.replace(/navLabel/gim, 'navLabel').replace(/navmap/gim, 'navMap').replace(/navpoint/gim, 'navPoint')
    st = st.replace(/if(.*?)endif/gim, '').replace(/<!--(.*?)-->/gim, '&nbsp;')
    st = st.replace(/<o:p><\/o:p>/gim, '')
    st = st.replace(/&nbsp;/gim, '&#160;')
    st = st.replace(/<p (.*?)>/gim, '\r\n<p $1>')
    // st = st.replace(/align="(.*?)"/gim, 'class="$1"')
    return st.replace(/><\/content>/gim, ' />').replace(/><\/item>/gim, ' />').replace(/><\/itemref>/gim, ' />').replace(/><\/reference>/gim, ' />')
  }

  createCss () {
    var sty = 'body { font-size: 1.0em; line-height: 1.8em; }\n'
    sty += '.cover { width: 100%; }\n'
    sty += 'p { margin: 0px; padding: 0px; }\n'
    sty += '.line { display: flex; justify-content: center; }\n'
    sty += '.line .solid { border-bottom: 1px solid; }\n'
    sty += '.line .inset { border-bottom: 2px solid; }\n'
    sty += '.line .dashed { border-bottom: 2px dashed; }\n'
    sty += '.line .double { border-bottom: 4px double; }\n'
    sty += '.line .large { width: 99%; }\n'
    sty += '.line .middle { width: 60%; }\n'
    sty += '.line .small { width: 30%; }\n'
    sty += '.img { display: flex; overflow: hidden; justify-content: center; }\n'
    sty += 'img.orgImage { margin: 0 auto; }\n'
    sty += 'img.fullImage { width: 100%; height: 100%; }\n'
    sty += 'div.mark_01 { border: 1px solid #ccc; margin: 10px; padding: 10px; }\n'
    sty += 'div.mark_02 { border-top: 2px solid #ccc; border-bottom: 2px solid #ccc; text-align: center; margin: 10px; padding: 10px; }\n'
    sty += 'div.mark_03 { border-left: 10px solid #ccc; margin: 10px; padding: 10px; }\n'
    sty += 'div.mark_04:before { color: #ccc; content:"“"; font-size: 5em; line-height: 0.1em; margin-right: 0.25em; vertical-align: -0.4em; }\n'
    sty += 'div.left { text-align: left; }\n'
    sty += 'div.right { text-align: right; }\n'
    sty += 'div.center { text-align: center; }\n'
    sty += 'div.justify { text-align: justify; }\n'
    sty += 'h2.left { text-align: left; }\n'
    sty += 'h2.right { text-align: right; }\n'
    sty += 'h2.center { text-align: center; }\n'
    sty += 'h2.justify { text-align: justify; }\n'
    sty += 'h3.left { text-align: left; }\n'
    sty += 'h3.right { text-align: right; }\n'
    sty += 'h3.center { text-align: center; }\n'
    sty += 'h3.justify { text-align: justify; }\n'
    sty += 'p.left { text-align: left; }\n'
    sty += 'p.right { text-align: right; }\n'
    sty += 'p.center { text-align: center; }\n'
    sty += 'p.justify { text-align: justify; }\n'
    sty += '.fontReform1 { font-size: 0.8em; }\n'
    sty += '.fontReform2 { font-size: 1em; }\n'
    sty += '.fontReform3 { font-size: 1.2em; }\n'
    sty += '.fontReform4 { font-size: 1.4em; }\n'
    sty += '.underline { text-decoration: underline; }\n'
    sty += '.strike { text-decoration: line-through; }\n'
    sty += '.indent { text-indent: 15px; }\n'
    return sty
  }
}



// WEBPACK FOOTER //
// ./src/components/js/Epub.js